import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUpload,
  faGift,
  faTrophy,
  faList,
  faHistory,
  faCheckCircle,
  faCamera,
} from "@fortawesome/free-solid-svg-icons";
import adimage1 from '../../assets/pageimages/roomanywhere/raindeximg1.png';
import adimage2 from '../../assets/navlogo.png';

export default function PhotoCanWin() {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const [drawEnabled, setDrawEnabled] = useState(true);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [activeTab, setActiveTab] = useState('current'); 
  const [thinkyResult, setThinkyResult] = useState(null);

  // const handleSoloUpload = (e) => {
  //   setSoloFile(e.target.files[0]);
  // };

  // const handleGroupUpload = (e) => {
  //   setGroupFile(e.target.files[0]);
  // };

  const [soloFile, setSoloFile] = useState(null);
  const [groupFile, setGroupFile] = useState(null);
  const [soloUploaded, setSoloUploaded] = useState(false);
  const [groupUploaded, setGroupUploaded] = useState(false);
  const [imageCaption, setImageCaption] = useState("");

  const [showUploadConfirmation, setShowUploadConfirmation] = useState(false);
  const [thinkyMessage, setThinkyMessage] = useState("");
  const [canUploadNow, setCanUploadNow] = useState(false);
  const [uploadNowDone, setUploadNowDone] = useState(false);

  async function verifySoloInGroup(soloFile, groupFile) {
    const { soloImageBuffer, groupImageBuffer } = req.files;
    const formData = new FormData();
    formData.append("image_file1", soloFile);
    formData.append("image_file2", groupFile);

     const res = await fetch("/api/faceverify", { method: "POST", body: formData });

    return await res.json();
  }

  // const askThinky = () => {
  //   if (soloFile && groupFile) {
  //     setThinkyMessage("Thinky suggests that you are all set to upload the image.");
  //     setCanUploadNow(true);
  //   } else {
  //     setThinkyMessage(
  //       "Thinky says something is wrong with your images as follows: Please upload both Solo and Group images."
  //     );
  //     setCanUploadNow(false);
  //   }
  // };

  // const askThinky = async () => {
  //   setThinkyMessage("Checking if the solo photo matches anyone in the group photo...");

  //   const result = await verifySoloInGroup(soloFile, groupFile);

  //   if (result.confidence > result.thresholds["1e-5"]) {
  //     setThinkyMessage("Matched! Same person found in the group photo.");
  //     setCanUploadNow(true);
  //   } else {
  //     setThinkyMessage("No match found. Please upload correct images.");
  //     setCanUploadNow(false);
  //   }
  // };

  async function verifySoloInGroup(soloFile, groupFile) {
    const formData = new FormData();
    formData.append("soloImage", soloFile);
    formData.append("groupImage", groupFile);

    const res = await fetch("/api/faceverify", {
      method: "POST",
      body: formData,
    });

    return await res.json();
  }

  // const askThinky = async () => {
  //   setThinkyMessage("Checking if the solo photo matches anyone in the group photo...");
  //   try {
  //     const result = await verifySoloInGroup(soloFile, groupFile);

  //     if (result.confidence > result.thresholds["1e-5"]) {
  //       setThinkyMessage("Matched! Same person found in the group photo.");
  //       setCanUploadNow(true);
  //     } else {
  //       setThinkyMessage("No match found. Please upload correct images.");
  //       setCanUploadNow(false);
  //     }
  //   } catch (err) {
  //     setThinkyMessage("Error verifying images: " + err.message);
  //     setCanUploadNow(false);
  //   }
  // };

  const askThinky = async () => {
    setThinkyMessage("Checking if the solo photo matches anyone in the group photo...");

    try {
      const result = await verifySoloInGroup(soloFile, groupFile);

      if (!result.thresholds) {
        setThinkyMessage("Error: No faces detected in one or both images.");
        setCanUploadNow(false);
        return;
      }

      if (result.confidence > result.thresholds["1e-5"]) {
        setThinkyMessage("Matched! Same person found in the group photo.");
        setCanUploadNow(true);
      } else {
        setThinkyMessage("No match found. Please upload correct images.");
        setCanUploadNow(false);
      }
    } catch (err) {
      setThinkyMessage("Error verifying images: " + err.message);
      setCanUploadNow(false);
    }
  };


  const handleFinalUpload = () => {
    setUploadNowDone(true);
    setCanUploadNow(false);
  };

    const activeContest = {
      prize: "₹100 Voucher",
      description: "Upload your photo when in a crowd & win!",
    };

    const dummyUploads = [
      { id: "UP001", time: "10:20 AM" },
      { id: "UP002", time: "12:45 PM" },
      { id: "UP003", time: "2:15 PM" },
    ];

    const dummyPhotoWinners = [
      { id: "Sanjeev", time: "11:00 AM" },
      { id: "Babita", time: "01:00 PM" },
      { id: "Srishti", time: "3:30 PM" },
    ];

    const dummyDrawWinners = [
      { id: "Srishti", time: "3:58 PM" },
    ];

    const myDrawWins = [
      { id: "UP002", prize: "₹100 Voucher", claimed: false },
      { id: "UP789", prize: "₹150 Train Off Peak Time Special Voucher", claimed: true },
    ];

    const myPhotoWins = [
      { id: "CK033", prize: "₹50 Voucher", claimed: false },
    ];

    const myClaims = [
      { id: "UP002", claimFor: "Photo Upload", status: "Under Review" },
      { id: "UP789", claimFor: "Photo Upload", status: "Approved" },
      { id: "CK033", claimFor: "Draw Click", status: "Approved" },
    ];

    const handleFileUpload = (e) => {
      const file = e.target.files[0];
      if (file) {
        setUploadedFile(file);
        setShowUploadConfirmation(true);
        setTimeout(() => setShowUploadConfirmation(false), 3000);
      }
    };

    // Tab switching logic using state (better than DOM manipulation)
    const switchTab = (tab) => {
      setActiveTab(tab);
    };

    // Initialize default tab
    useEffect(() => {
      switchTab('current');
    }, []);

  const renderTabContent = () => {
    switch (activeTab) {
      case "current":
        case "current":
          return (
            <div className="rounded-2xl shadow p-4 relative bg-black border border-teal-200 space-y-4">
              {/* Dummy Ad */}
              <div
                className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
                onClick={() => navigate("/roomanywhere")}
              >
                <div className="flex-shrink-0 w-20 h-20 rounded overflow-hidden bg-gray-700">
                  <img
                    src={adimage1} 
                    alt="Ad"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex flex-col text-left">
                  <p className="text-xs uppercase text-gray-400 mb-1">Think5Whys Ad</p>
                  <p className="font-semibold text-lg"><span className="text-yellow-200">RoomAnywhere</span>: Make Indoor and Outdoor Room (Patent Applied)</p>
                  <p className="text-sm mt-1">Click to see more!</p>
                </div>
              </div>
              <h2 className="text-lg font-semibold text-center">
                Prize: {activeContest.prize}
              </h2>

              <p className="text-center mt-1">{activeContest.description}</p>

              <div>
                <label className="text-sm text-white">Location</label>
                <select className="h-10 w-full mt-1 p-2 rounded-lg bg-gray-800 text-white border border-gray-600">
                  <option value="">Select Location</option>
                  <option>Eatery</option>
                  <option>Factory</option>
                  <option>Festival</option>
                  <option>Get Together</option>
                  <option>Local Train</option>
                  <option>Market</option>
                  <option>Metro</option>
                  <option>Office</option>
                  <option>Other</option>
                  <option>Party</option>
                  <option>Train Journey</option>
                </select>
              </div>

              <input
                id="file-upload-solo"
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(e) => {
                  setSoloFile(e.target.files[0]);
                  setSoloUploaded(true);
                  setShowUploadConfirmation(true);
                  setTimeout(() => setShowUploadConfirmation(false), 2000);
                }}
                disabled={soloUploaded}
              />

              <input
                id="file-upload-group"
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(e) => {
                  setGroupFile(e.target.files[0]);
                  setGroupUploaded(true);
                  setShowUploadConfirmation(true);
                  setTimeout(() => setShowUploadConfirmation(false), 2000);
                }}
                disabled={groupUploaded}
              />

              <div className="grid grid-cols-2 gap-2 place-items-center">
                
                <label
                  htmlFor="file-upload-solo"
                  className={`w-full py-2 rounded-lg flex items-center justify-center gap-2
                  ${soloUploaded ? "bg-gray-500 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 text-white"}`}
                >
                  <FontAwesomeIcon icon={faCamera} />
                  Select Current Solo Image
                </label>

                <label
                  htmlFor="file-upload-group"
                  className={`w-full py-2 rounded-lg flex items-center justify-center gap-2
                  ${groupUploaded ? "bg-gray-500 cursor-not-allowed" : "bg-teal-600 hover:bg-teal-700 text-white"}`}
                >
                  <FontAwesomeIcon icon={faCamera} />
                  Select Group Image
                </label>

              </div>
              <div className="flex flex-col justify-center ">
                <button
                  onClick={askThinky}
                  disabled={!(soloUploaded && groupUploaded) || uploadNowDone}
                  className={`mt-4 w-full py-2 rounded-lg 
                    ${
                      uploadNowDone
                        ? "bg-gray-500 cursor-not-allowed text-gray-300"
                        : soloUploaded && groupUploaded
                        ? "bg-purple-600 hover:bg-purple-700 text-white"
                        : "bg-gray-600 cursor-not-allowed text-gray-300"
                    }
                  `}
                >
                  Ask Thinky AI Agent to Verify Images
                </button>

                {thinkyMessage && !uploadNowDone && (
                  <div className="bg-black text-white p-3 rounded-lg text-sm border border-green-400">
                    {thinkyMessage}
                  </div>
                )}
              </div>

              {canUploadNow && (
                <>
                  <input
                    type="text"
                    maxLength={100}
                    value={imageCaption}
                    onChange={(e) => setImageCaption(e.target.value)}
                    disabled={uploadNowDone}
                    placeholder="Write about the image / photo in max 100 characters"
                    className={`w-full p-2 rounded-lg bg-gray-800 text-white border border-gray-600 mt-2
                      ${uploadNowDone ? "cursor-not-allowed opacity-50" : ""}
                    `}
                  />

                  <button
                    onClick={handleFinalUpload}
                    disabled={uploadNowDone}
                    className={`w-full py-2 rounded-lg mt-2
                      ${
                        uploadNowDone
                          ? "bg-gray-500 cursor-not-allowed"
                          : "bg-blue-600 hover:bg-blue-700 text-white"
                      }
                    `}
                  >
                    {uploadNowDone ? "Uploaded Successfully" : "Upload Now"}
                  </button>
                </>
              )}

              {uploadNowDone && (
                <div className="bg-black text-white p-3 rounded-lg text-sm border border-green-400 mt-2 text-center">
                  ✅ Your images are successfully uploaded!  
                  <br />  
                  🎉 You are now participating in the contest!
                </div>
              )}
              <div
                  className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
                  onClick={() => window.open("https://www.think5whys.com", "_blank")}
                >
                <div className="flex-shrink-0 w-16 h-16 bg-gray-700 rounded overflow-hidden">
                  <img
                    src={adimage2}
                    alt="Ad"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex flex-col text-left">
                  <p className="text-xs uppercase text-gray-400 mb-1">Google Ad</p>
                  <p className="font-semibold text-lg">Think5Whys: Your Platform for Transformation</p>
                  <p className="text-sm mt-1">Click to see more!</p>
                </div>
              </div>               
            </div>
          );

      case 'uploads':
        return (
          <div className="rounded-2xl shadow p-4 bg-black border border-teal-200 text-white space-y-2">
            <div
                className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
                onClick={() => window.open("https://www.think5whys.com", "_blank")}
              >
              <div className="flex-shrink-0 w-16 h-16 bg-gray-700 rounded overflow-hidden">
                <img
                  src={adimage2}
                  alt="Ad"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex flex-col text-left">
                <p className="text-xs uppercase text-gray-400 mb-1">Google Ad</p>
                <p className="font-semibold text-lg">Think5Whys: Your Platform for Transformation</p>
                <p className="text-sm mt-1">Click to see more!</p>
              </div>
            </div>            
            {dummyUploads.map((u) => (
              <div
                key={u.id}
                className="p-2 border rounded-xl text-sm flex justify-between"
              >
                <span>Upload ID: {u.id}</span>
                <span>{u.time}</span>
              </div>
            ))}
          </div>
        );
      case 'draw':
        return (
          <div className="rounded-2xl shadow p-4 bg-black border border-teal-200 text-white text-center space-y-3">
            <div
                className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
                onClick={() => window.open("https://www.think5whys.com", "_blank")}
              >
              <div className="flex-shrink-0 w-16 h-16 bg-gray-700 rounded overflow-hidden">
                <img
                  src={adimage2}
                  alt="Ad"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col text-left">
                <p className="text-xs uppercase text-gray-400 mb-1">Google Ad</p>
                <p className="font-semibold text-lg">Think5Whys: Your Platform for Transformation</p>
                <p className="text-sm mt-1">Click to see more!</p>
              </div>
            </div>
            <p className="text-sm">Click the Draw button if it's active!</p>
            <button
              disabled={!drawEnabled}
              onClick={() => setDrawEnabled(false)}
              className={`w-32 py-2 rounded-xl text-white ${drawEnabled ? "bg-blue-600 hover:bg-blue-800" : "bg-gray-400 cursor-not-allowed"}`}
            >
              🎉 Draw
            </button>
            {!drawEnabled && (
              <p className="text-yellow-200 text-lg">Congratulations. You clicked! You may be a lucky winner for making the draw. Our Thinky AI will update you soon if you are the winner! </p>
            )}
          </div>
        );
      case 'winnerlog':
        return (
          <>
            <div className="rounded-2xl shadow p-4 bg-black border border-blue-300 text-white space-y-2">
              
              {/* Dummy Ad */}
              <div
                className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
                onClick={() => navigate("/roomanywhere")}
              >
                <div className="flex-shrink-0 w-20 h-20 rounded overflow-hidden bg-gray-700">
                  <img
                    src={adimage1} 
                    alt="Ad"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex flex-col text-left">
                  <p className="text-xs uppercase text-gray-400 mb-1">Think5Whys Ad</p>
                  <p className="font-semibold text-lg"><span className="text-yellow-200">RoomAnywhere</span>: Make Indoor and Outdoor Room (Patent Applied)</p>
                  <p className="text-sm mt-1">Click to see more!</p>
                </div>
              </div>

              <p>Todays Making Draw Winners</p>
              {dummyDrawWinners.map((w) => (
                <div
                  key={w.id}
                  className="p-2 border rounded-xl text-sm flex justify-between"
                >
                  <span>Winner ID: {w.id}</span>
                  <span>{w.time}</span>
                </div>
              ))}
            </div>
            <div className="mt-2 rounded-2xl shadow p-4 bg-black border border-blue-400 text-white space-y-2">
              <p>Todays Photo Draw Winners</p>
              {dummyPhotoWinners.map((w) => (
                <div
                  key={w.id}
                  className="p-2 border rounded-xl text-sm flex justify-between"
                >
                  <span>Winner ID: {w.id}</span>
                  <span>{w.time}</span>
                </div>
              ))}
            </div>
          </>          
        );
      case 'mywins':
        return (
          <>
            <div className="rounded-2xl shadow p-4 bg-black border border-blue-200  text-white space-y-2">
              {/* Dummy Ad */}
              <div
                className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
                onClick={() => window.open("https://www.think5whys.com", "_blank")}
              >
                <div className="flex-shrink-0 w-16 h-16 bg-gray-700 rounded overflow-hidden">
                  <img
                    src={adimage2}
                    alt="Ad"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex flex-col text-left">
                  <p className="text-xs uppercase text-gray-400 mb-1">Google Ad</p>
                  <p className="font-semibold text-lg">Think5Whys: Your Platform for Transformation</p>
                  <p className="text-sm mt-1">Click to see more!</p>
                </div>
              </div>

              <p>My Draw Wins</p>              
              {myDrawWins.map((w) => (
                <div
                  key={w.id}
                  className="p-2 border rounded-xl text-sm flex justify-between items-center"
                >
                  <div>
                    <p>ID: {w.id}</p>
                    <p>Prize: {w.prize}</p>
                  </div>
                  <button
                    disabled={w.claimed}
                    onClick={() => {/* Dummy claim action - could set claimed to true */ }}
                    className={`w-20 px-3 py-1 rounded-lg text-xs ${w.claimed ? "bg-gray-300 cursor-not-allowed" : "bg-blue-600 text-white hover:bg-blue-700"}`}
                  >
                    {w.claimed ? "Claimed" : "Claim"}
                  </button>
                </div>
              ))}
            </div>
            <div className="mt-2 rounded-2xl shadow p-4 bg-black border border-blue-400  text-white space-y-2">
              <p>My Photo Draw Wins</p>
              {myPhotoWins.map((w) => (
                <div
                  key={w.id}
                  className="p-2 border rounded-xl text-sm flex justify-between items-center"
                >
                  <div>
                    <p>ID: {w.id}</p>
                    <p>Prize: {w.prize}</p>
                  </div>
                  <button
                    disabled={w.claimed}
                    onClick={() => {/* Dummy claim action - could set claimed to true */ }}
                    className={`w-20 px-3 py-1 rounded-lg text-xs ${w.claimed ? "bg-gray-300 cursor-not-allowed" : "bg-blue-600 text-white hover:bg-blue-700"}`}
                  >
                    {w.claimed ? "Claimed" : "Claim"}
                  </button>
                </div>
              ))}
            </div>
          </>
        );
      case 'claims':
        return (
          <div className="rounded-2xl shadow p-4 bg-black border border-teal-200 text-white space-y-2">
            {/* Dummy Ad */}
            <div
              className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
              onClick={() => navigate("/roomanywhere")}
            >
              <div className="flex-shrink-0 w-20 h-20 rounded overflow-hidden bg-gray-700">
                <img
                  src={adimage1} 
                  alt="Ad"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col text-left">
                <p className="text-xs uppercase text-gray-400 mb-1">Think5Whys Ad</p>
                <p className="font-semibold text-lg"><span className="text-yellow-200">RoomAnywhere</span>: Make Indoor and Outdoor Room (Patent Applied)</p>
                <p className="text-sm mt-1">Click to see more!</p>
              </div>
            </div>            
            {myClaims.map((c) => (
              <div
                key={c.id}
                className="p-2 border rounded-xl text-sm flex justify-between"
              >
                <span>ID: {c.id}</span>
                <span>{c.claimFor}</span>
                <span>Status: {c.status}</span>
              </div>
            ))}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen flex flex-col p-1 mx-auto bg-black">
      <header className="sticky top-0 z-50 bg-black border-b border-teal-200 mb-2 px-4 py-3 flex items-center justify-between flex-shrink-0">
        <div className="flex flex-col">
          <motion.h1
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-2xl font-bold text-center"
          >
            📸 PhotoCanWin
          </motion.h1>
          <div className="text-[11px] text-white">Win With Your Photo When In A Crowd!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="mt-4 p-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-gray-700 text-sm text-white hover:bg-gray-800"
              >
                Login
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>
      
      <main className="flex-1 space-y-4 overflow-auto">
        {/* Tabs */}
        <div className="w-full">
          <div className="grid grid-cols-3 lg:grid-cols-6 gap-1 text-[11px] font-medium bg-black p-1 rounded-lg place-items-center">
            <button 
              data-tab="current" 
              onClick={() => switchTab('current')} 
              className={`tab-btn flex flex-col items-center py-2 px-1 rounded-lg transition-colors ${
                activeTab === 'current' ? 'bg-blue-600 rounded-xl shadow' : 'text-white hover:bg-blue-800'
              }`}
            >
              <FontAwesomeIcon icon={faGift} className="mb-1" /> Current
            </button>
            <button 
              data-tab="uploads" 
              onClick={() => switchTab('uploads')} 
              className={`tab-btn flex flex-col items-center py-2 px-1 rounded-lg transition-colors ${
                activeTab === 'uploads' ? 'bg-blue-600 rounded-xl shadow' : 'text-white hover:bg-blue-800'
              }`}
            >
              <FontAwesomeIcon icon={faUpload} className="mb-1" /> Uploads
            </button>
            <button 
              data-tab="draw" 
              onClick={() => switchTab('draw')} 
              className={`tab-btn flex flex-col items-center py-2 px-1 w-32 rounded-lg transition-colors ${
                activeTab === 'draw' ? 'bg-blue-600 rounded-xl shadow' : 'text-white hover:bg-blue-800'
              }`}
            >
              <FontAwesomeIcon icon={faTrophy} className="mb-1" /> Draw
            </button>
            <button 
              data-tab="winnerlog" 
              onClick={() => switchTab('winnerlog')} 
              className={`tab-btn flex flex-col items-center py-2 px-1 rounded-lg transition-colors ${
                activeTab === 'winnerlog' ? 'bg-blue-600 rounded-xl shadow' : 'text-white hover:bg-blue-800'
              }`}
            >
              <FontAwesomeIcon icon={faList} className="mb-1" /> Winners
            </button>
            <button 
              data-tab="mywins" 
              onClick={() => switchTab('mywins')} 
              className={`tab-btn flex flex-col items-center py-2 px-1 rounded-lg transition-colors ${
                activeTab === 'mywins' ? 'bg-blue-600 rounded-xl shadow' : 'text-white hover:bg-blue-800'
              }`}
            >
              <FontAwesomeIcon icon={faHistory} className="mb-1" /> My Wins
            </button>
            <button 
              data-tab="claims" 
              onClick={() => switchTab('claims')} 
              className={`tab-btn flex flex-col items-center py-2 px-1 rounded-lg transition-colors ${
                activeTab === 'claims' ? 'bg-blue-600 rounded-xl shadow' : 'text-white hover:bg-blue-800'
              }`}
            >
              <FontAwesomeIcon icon={faCheckCircle} className="mb-1" /> Claims
            </button>
          </div>
          {/* CONTENT AREA */}
          <div className="mt-4">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.2 }}
                className="tab-content"
              >
                {renderTabContent()}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </main>
      
      <footer className="mt-auto bg-black border-t border-teal-200 text-gray-400 py-4 flex-shrink-0">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
}